export default __webpack_public_path__ + "static/media/info_outline_24px.4b6d0254.svg";